import React from 'react';
import {Button, Colors, Intent} from '@blueprintjs/core';
import {IconNames} from '@blueprintjs/icons';

import {jinjaParamIcon} from '../../../../utils/custom-icons';

type Callback = (value?: any) => void;

interface BaseButtonProps {
  show: boolean;
  loading: boolean;
  onClick?: Callback | null;
  disabled?: boolean;
  showLabel?: boolean;
}

interface ExecuteButtonProps extends BaseButtonProps {
}

interface PreviewButtonProps extends BaseButtonProps {
  isPreview: boolean;
}

export const ExecuteButton = ({show, loading, onClick, disabled, showLabel}: ExecuteButtonProps) => {
  if (!show || !onClick) {
    return null;
  }

  return (
    <Button
      className="execute-button"
      text={showLabel ? 'Run' : ''}
      intent={disabled ? Intent.NONE : Intent.PRIMARY}
      icon={IconNames.PLAY}
      onClick={onClick}
      small={true}
      loading={loading}
      disabled={disabled}
    />
  );
};

export const PreviewButton = ({
  isPreview,
  show,
  loading,
  onClick,
  disabled,
  showLabel,
}: PreviewButtonProps) => {
  if (!show || !onClick) {
    return null;
  }

  return (
    <Button
      className="preview-button"
      text={showLabel ? 'Render' : ''}
      intent={Intent.NONE}
      icon={jinjaParamIcon({
        fill: isPreview ? Colors.BLUE3 : Colors.GRAY3,
        viewBoxDefault: '7 -7 12 37',
      })}
      onClick={onClick}
      small={true}
      loading={loading}
      disabled={disabled}
      minimal={true}
      active={isPreview}
    />
  );
};
